import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getAssignationManagementResidueFinalDestinationList as getAssignationManagementResidueFinalDestinationListApi,
	getAssignationManagementResidueFinalDestination as getAssignationManagementResidueFinalDestinationApi,
	addNewAssignationManagementResidueFinalDestination as addNewAssignationManagementResidueFinalDestinationApi,
	updateAssignationManagementResidueFinalDestination as updateAssignationManagementResidueFinalDestinationApi,
	deleteAssignationManagementResidueFinalDestination as deleteAssignationManagementResidueFinalDestinationApi,
	registerAssignationManagementResidueFinalDestination as registerAssignationManagementResidueFinalDestinationApi
} from '../../helpers/residue/backend_helper';

export const getAssignationManagementResidueFinalDestinationList = createAsyncThunk('assignationManagementResidueFinalDestinations/getAssignationManagementResidueFinalDestinationList', async (params) => {
	try {
		const response = getAssignationManagementResidueFinalDestinationListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getAssignationManagementResidueFinalDestination = createAsyncThunk('assignationManagementResidueFinalDestinations/getAssignationManagementResidueFinalDestination', async assignationManagementResidueFinalDestination_id => {
	try {
		const response = getAssignationManagementResidueFinalDestinationApi(assignationManagementResidueFinalDestination_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewAssignationManagementResidueFinalDestination = createAsyncThunk('assignationManagementResidueFinalDestinations/addNewAssignationManagementResidueFinalDestination', async assignationManagementResidueFinalDestination => {
	try {
		const response = addNewAssignationManagementResidueFinalDestinationApi(assignationManagementResidueFinalDestination);
		toast.success('asignación agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar asignación.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateAssignationManagementResidueFinalDestination = createAsyncThunk('assignationManagementResidueFinalDestinations/updateAssignationManagementResidueFinalDestination', async (assignationManagementResidueFinalDestination) => {
		try {
			const response = updateAssignationManagementResidueFinalDestinationApi(assignationManagementResidueFinalDestination);
			toast.success('AssignationManagementResidueFinalDestination actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar asignación.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteAssignationManagementResidueFinalDestination = createAsyncThunk('assignationManagementResidueFinalDestinations/deleteAssignationManagementResidueFinalDestination', async assignationManagementResidueFinalDestination => {
	try {
		const response = await deleteAssignationManagementResidueFinalDestinationApi(assignationManagementResidueFinalDestination);
		toast.success('AssignationManagementResidueFinalDestination eliminado exitosamente.', { autoClose: 3000 });
		return { assignationManagementResidueFinalDestination, ...response };
	} catch (error) {
		toast.error('Error al eliminar asignación.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const getRegisterAssignationManagementResidueFinalDestination = createAsyncThunk('assignationManagementResidueFinalDestinations/getRegisterAssignationManagementResidueFinalDestination', async assignationManagementResidueFinalDestination => {
	try {
		const response = getRegisterAssignationManagementResidueFinalDestinationApi(assignationManagementResidueFinalDestination);
		console.log(response)
		// toast.success('Guía cargada exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		console.log(error)
		toast.error('Error al obtener datos de asignación.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const registerAssignationManagementResidueFinalDestination = createAsyncThunk('assignationManagementResidueFinalDestinations/registerAssignationManagementResidueFinalDestination', async assignationManagementResidueFinalDestination => {
	try {
		const response = await registerAssignationManagementResidueFinalDestinationApi(assignationManagementResidueFinalDestination);
		toast.success(`Asignaciónes registradas exitosamente.`, { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al registrar asignación.', { autoClose: 3000 });
		throw new Error(error);
	}
});